import React, { Component } from "react";
import styles from "./controlDrivers.module.scss";
import { withDrivers } from "../../../shared/containers/containerDrivers";
import { withAuth } from "../../../shared/containers/containerAuth";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { states } from "../../../reducers/queriesStates";
import ControlDriverTool from "./ControlDriverTool";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import Preloader from "../../../shared/items/static/preloader";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";

const PATHNAME = "/controls/drivers/";

class ControlDrivers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteDriver: null,
    };
  }

  onCreateDriverClickHandler() {
    const { onSelectDriver } = this.props;

    onSelectDriver({
      id: null,
      firstName: null,
      lastName: null,
      middleName: null,
      phone: null,
      birthday: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      licenseNumber: null,
      licenseWhoGrant: null,
      licenseDate: new Date(),
      licensePeriod: new Date(),
      categories: {},
    });
  }

  componentDidMount() {
    const { onGetDrivers, driversDataState, drivers, selectedGroup, onSelectDriver } = this.props;

    if (driversDataState === states.NOT_REQUESTED) {
      onGetDrivers();
    }

    if (driversDataState === states.READY && drivers.length > 0) {
      if (window.location.pathname.includes(PATHNAME) && selectedGroup === null) {
        const id = window.location.pathname.replace(PATHNAME, "");

        if (id !== "") {
          const driver = drivers.filter((x) => {
            return x.id === id;
          })[0];

          if (driver !== undefined) {
            onSelectDriver(driver);
          }
        }
      }
    }
  }

  onHandleChangeClick(id) {
    const { drivers, onSelectDriver } = this.props;

    const driver = drivers.filter((x) => {
      return x.id === id;
    })[0];

    if (driver !== undefined) {
      onSelectDriver({
        ...driver,
        birthday: new Date(Date.parse(driver.birthday)),
        licenseDate: new Date(Date.parse(driver.licenseDate)),
        licensePeriod: new Date(Date.parse(driver.licensePeriod)),
      });
    }
  }

  onHandleDeleteClick(id) {
    const { drivers } = this.props;

    const driver = drivers.filter((x) => {
      return x.id === id;
    })[0];

    if (driver !== undefined) this.setState({ deleteDriver: driver });
  }

  onDeleteHandler() {
    const { onDeleteDriver } = this.props;
    const { deleteDriver } = this.state;

    onDeleteDriver({ id: deleteDriver.id });
    this.setState({ deleteDriver: null });
  }

  getColumns() {
    const renderSensorCell = (params) => {
      return (
        <div style={{ display: "flex", fontSize: "11px", padding: "5px" }}>
          <div>
            <TooltipWrapper title={"Изменить, посмотреть детальнее"} position="top">
              <EditIcon
                fontSize="small"
                style={{ color: "black" }}
                onClick={(e) => {
                  e.stopPropagation();

                  this.onHandleChangeClick(params.id);
                }}
              />
            </TooltipWrapper>
          </div>
          <div style={{ marginLeft: "15px" }}>
            <TooltipWrapper title={"Удалить"} position="top">
              <DeleteIcon
                fontSize="small"
                onClick={(e) => {
                  e.stopPropagation();

                  this.onHandleDeleteClick(params.id);
                }}
              />
            </TooltipWrapper>
          </div>
        </div>
      );
    };

    return [
      {
        field: "lastName",
        headerName: "Фамилия",
        width: 150,
      },
      {
        field: "firstName",
        headerName: "Имя",
        width: 150,
      },
      {
        field: "middleName",
        headerName: "Отчество",
        width: 150,
      },
      {
        field: "birthday",
        headerName: "Дата рождения",
        width: 110,
        type: "date",
      },
      {
        field: "licenseDate",
        headerName: "Дата выдачи",
        width: 110,
        type: "date",
      },
      {
        field: "licensePeriod",
        headerName: "Действительно до",
        width: 110,
        type: "date",
      },
      {
        field: "categories",
        headerName: "Категория",
        width: 100,
      },
      {
        field: "licenseNumber",
        headerName: "Серийный номер водительских прав",
        width: 150,
      },
      {
        field: "phone",
        headerName: "Телефон",
        width: 150,
      },
      {
        field: "description",
        headerName: "Доп. инфо.",
        width: 150,
      },
      {
        field: "",
        headerName: "",
        width: 80,
        renderCell: renderSensorCell,
      },
    ];
  }

  getRows() {
    const { drivers } = this.props;

    return drivers.map((x) => {
      const categories = Object.values(x.categories).reduce((accumulator, current) => {
        if (current === "None") return "";

        return accumulator + `${current}; `;
      }, "");

      return {
        ...x,
        birthday: new Date(Date.parse(x.birthday)),
        licenseDate: new Date(Date.parse(x.licenseDate)),
        licensePeriod: new Date(Date.parse(x.licensePeriod)),
        categories,
      };
    });
  }

  handleSelectionChange(params) {
    const { drivers, onSelectDriverForUnits } = this.props;

    const driver = drivers.filter((x) => {
      return x.id === params[0];
    })[0];

    if (driver !== undefined) {
      onSelectDriverForUnits(driver);
    } else {
      onSelectDriverForUnits(null);
    }
  }

  componentWillUnmount() {
    const { onSelectDriverForUnits } = this.props;
    onSelectDriverForUnits(null);
  }

  onDownloadClickHandle() {
    const { onDownloadDrivers, data } = this.props;
    onDownloadDrivers(data.companyTitle);
  }

  render() {
    const { selectedDriver, driversDownloadDataState } = this.props;

    const { deleteDriver } = this.state;

    return (
      <div className={styles.controlDriversContainer}>
        {selectedDriver === null ? (
          <div className={styles.createDriversButton}>
            <TooltipWrapper title={"Добавить водителя"} position="right">
              <ControlPointIcon fontSize="large" onClick={this.onCreateDriverClickHandler.bind(this)} />
            </TooltipWrapper>
          </div>
        ) : null}

        {selectedDriver !== null ? (
          <div className={null}>
            <ControlDriverTool />
          </div>
        ) : null}

        {selectedDriver === null ? (
          <div className={styles.tableContainer}>
            {driversDownloadDataState === states.REQUEST ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            ) : (
              <div style={{ display: "flex", marginBottom: "10px", alignItems: "center" }}>
                <ButtonIconWrapper type={"primary"} icon="save" disabled={false} handleClick={this.onDownloadClickHandle.bind(this)} />
                <div style={{ padding: "10px" }}>Скачть список водителей</div>
              </div>
            )}

            <DataGrid
              rowHeight={30}
              ref={"DataGrid"}
              disableColumnSelector={true}
              disableColumnFilter={false}
              localeText={{
                ...dateGridLocalTextOptions,
                footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
                MuiTablePagination: {
                  disabled: false,
                  rowsPerPage: 100,
                  rowsPerPageOptions: 100,
                  labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} из ${count === -1 ? `больше ${to}` : count}`,
                },
              }}
              rows={this.getRows()}
              columns={this.getColumns()}
              onRowSelectionModelChange={this.handleSelectionChange.bind(this)}
              /*  disableRowSelectionOnClick */
            />
          </div>
        ) : null}

        {deleteDriver !== null ? (
          <ModalConfirmWindow isOpen={deleteDriver !== null}>
            <DeleteConfirm
              onConfirmHandle={this.onDeleteHandler.bind(this)}
              onNotConfirmHandle={(e) => {
                this.setState({ deleteDriver: null });
              }}
              text={`Удалить водителя ${deleteDriver.lastName} ${deleteDriver.firstName} ${deleteDriver.middleName}?`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withDrivers(React.memo(ControlDrivers)));
